<template>
  <el-form
    class="form-tag"
    ref="vmlistSticker"
    :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
  >
    <el-row :gutter="12" :key="index" v-for="(item, index) in listSticker">
      <el-col :span="4" :key="i" v-for="(st, i) in item">
        <span @click="fnSendStickerToLine(st.link)">
          <img :src="st.link" class="ui-path-img" />
        </span>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { Form, Row, Col } from 'element-ui';
import axios from 'axios';
import { groupBy } from 'rxjs/operators';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      listSticker: [],
    };
  },
  computed: {
    ...mapGetters('chat', ['sickersAndOftenImage']),
  },
  components: {
    [Form.name]: Form,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  methods: {
    fnSendStickerToLine(params) {
      this.$emit('send-sticker-line', params);
    },
  },
  created() {
    //load data
    if (this.sickersAndOftenImage.length == 0) {
      this.$store.dispatch('chat/loadSickerandfile').then(value => {
        if (value.length > 0) {
          this.listSticker = _.chunk(
            _.filter(this.sickersAndOftenImage, function(v) {
              return v.type == 'sticker';
            }),
            6,
          );
        }
      });
    } else {
      this.listSticker = _.chunk(
        _.filter(this.sickersAndOftenImage, function(v) {
          return v.type == 'sticker';
        }),
        6,
      );
    }
  },
};
</script>
<style scoped>
.el-form.form-tag .el-row .el-col span {
  cursor: pointer;
}
.el-form.form-tag.on-mobile {
  position: absolute;
  width: 100%;
  z-index: 3000;
  bottom: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Sticker.vue